import imageCompression from "browser-image-compression";
import SimpleErrorMessage from "components/InputsMex/containers/SimpleErrorMessage";
import { ControllerRender } from "components/InputsMex/inputs";
import { urlUploadFile } from "constants/urls_garantia";
import useCustomToast from "hooks/useCustomToasts";
import React, { useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import imgFile from "../img/step3.png";

const UploadFile = ({ onSubmit, loadingFecha }) => {
  const { handleSubmit } = useFormContext();
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);
  const { addWarningToast } = useCustomToast();

  const uploadFile = async (file) => {
    console.log("FILE: ", file);

    const compressedFile = await imageCompression(file, {
      maxSizeMB: 2,
      useWebWorker: true,
    });

    const formData = new FormData();

    formData.append("file", compressedFile);

    const res = await fetch(urlUploadFile, {
      method: "POST",
      body: formData,
    }).then((data) => data.json());

    if (res?.transaccion && res?.url) {
      return res?.url;
    } else if (res?.errors?.file?.[0]) {
      addWarningToast(res?.errors?.file?.[0]);
    } else {
      addWarningToast("Ha ocurrido un problema al momento de subir la imagen");
    }

    return null;
  };

  return (
    <div
      className='text-center d-flex flex-column align-items-center mt-5'
      style={{
        backgroundColor: "#f4f4f4",
        paddingBottom: "6rem",
        paddingTop: "6rem",
      }}>
      <div className='mb-5'>
        <div className='d-flex flex-row flex-wrap justify-content-center'>
          <h3 className='align-self-center mr-5' style={{ width: "300px" }}>
            Compártenos tu ticket de compra al dar click en el botón
          </h3>
          <div
            className='d-flex flex-column align-self-center'
            style={{ width: "285px" }}>
            <ControllerRender
              name='ticket'
              rules={{ required: "Este campo es obligatorio" }}
              render={({ value, onChange }) => (
                <React.Fragment>
                  <button
                    onClick={() => {
                      fileInputRef.current.value = null;
                      fileInputRef.current.click();
                      onChange(null);
                    }}
                    disabled={uploading}
                    className='btn btn-primary mb-3'>
                    SUBIR TICKET
                  </button>
                  {uploading && <p>Subiendo archivo...</p>}
                  <div className='d-flex flex-row'>
                    <input
                      className='d-none'
                      type='file'
                      accept='image/*'
                      ref={fileInputRef}
                      // capture='camera'
                      onChange={async (evt) => {
                        setUploading(true);
                        console.log("ON CHANGE: ", evt);
                        try {
                          const file = evt.target.files?.[0];
                          if (file) {
                            onChange(await uploadFile(file));
                          }
                        } catch (error) {
                          addWarningToast(
                            "Ha ocurrido un problema al subir el archivo, por favor intenta nuevamente"
                          );
                        }
                        setUploading(false);
                      }}
                    />
                    {value && (
                      <React.Fragment>
                        <div className='border bg-white p-2 w-100 text-left'>
                          <a
                            className='ml-3 text-dark url_ticket'
                            href={value}
                            style={{ fontSize: "20px" }}
                            target='__blank'
                            rel='noopener noreferrer'>
                            <i className='pi pi-eye mr-3' />
                            Ticket
                          </a>
                        </div>
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            outline: "none",
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            onChange(null);
                          }}
                          className='ml-2'>
                          <i className='pi pi-times' />
                        </button>
                      </React.Fragment>
                    )}
                  </div>
                </React.Fragment>
              )}
            />
          </div>
          <img src={imgFile} style={{ width: "215px" }} alt='file__banner' />
        </div>
        <SimpleErrorMessage name='ticket' />
      </div>
      <div>
        <button
          className='text-center btn btn-primary'
          style={{ paddingLeft: "8rem", paddingRight: "8rem" }}
          type='button'
          onClick={handleSubmit(onSubmit)}
          disabled={loadingFecha}>
          ENVIAR
        </button>
      </div>
    </div>
  );
};

export default UploadFile;
